import newpolicyData from './newpolicyData';

class APCPUtil {

  addBgClass(examData) {
    let currentbg = 'grey';
    for (const [i, exam] of examData.entries()) {
      if (i === 0) {
        exam.rowData.bgColor = currentbg;
      }
      else {
        if (exam.rowData.examTitle === examData[i - 1].rowData.examTitle) {
          exam.rowData.bgColor = currentbg;
        }
        else {
          //reset currentbg
          currentbg = currentbg === 'grey' ? 'white' : 'grey';
          exam.rowData.bgColor = currentbg;
        }
      }
    }
  }

  constructModuleId(myarr, moduleIdMap, examTitle) {
    let mymid = -1;
    if (myarr.length > 0) {
      //find largest sub index and add 1 to be mid
      myarr.sort((a, b) => {
        if (a.rowData.moduleId < b.rowData.moduleId) {
          return 1;
        }
        else { return -1; }
      });
      const mid = myarr[0].rowData.moduleId.split('-');
      mymid = mid[0] + `-` + (parseInt(mid[1]) + 1);
    }
    else {
      let currentMid = '';
      for (const [key, value] of Object.entries(moduleIdMap)) {
        if (value === examTitle) {
          currentMid = key;
          break;
        }
      }
      mymid = `${currentMid}-0`;
    }
    return mymid;
  }

  constructCurrentValue(answers, currentValue) {
      Object.keys(answers).forEach(key => {
        const keyarr = key.split('_');
        const lookkey = keyarr[3];
        if (Array.isArray(answers[key])) {
          currentValue[`${lookkey}`] = answers[key].filter(e => e !== '').join('|');
        }
        else {
          currentValue[`${lookkey}`] = answers[key];
        }
      });
  }

  constructQuestions(answers, questions) {
    questions.map(q => { q.current_value = ''; });
    Object.keys(answers).forEach(key => {
      const keyarr = key.split('_');
      const lookkey = keyarr[3];
      for (const mq of questions) {
        if (mq['api_attribute'] === lookkey) {
          if (Array.isArray(answers[key])) {
            mq.current_value = answers[key].filter(e => e !== '').join('|');
          }
          else {
            mq.current_value = answers[key];
          }
        }
      }
    });
  }

  constructRowData(answers, rowData) {
    Object.keys(answers).forEach(key => {
      const keyarr = key.split('_');
        rowData[keyarr[3]] = answers[key];
    });
  }

  realQuestionsFromTemplate(questions) {
    const a = questions.filter(q => (q.id !== 'APCPEXAMTITLE' && q.id !== 'ReadOnly'));
    return a;
  }

  addModuleByAnswers(moduleDataArr, answers, moduleIdMap, questionTemplate) {
    const newRow = {};
    let mybgcolor = '';
    const exarr = Object.keys(answers).filter(a => a.includes('APCPEXAMTITLE'));
    const mixids = exarr[0].split('_');
    const examTitle = answers[exarr[0]];
    const seTitle = this.shortName(examTitle);
    const myarr = moduleDataArr.filter(m => m.rowData.examTitle === examTitle);

    let mymid = this.constructModuleId(myarr, moduleIdMap, examTitle);
    mybgcolor = myarr?.length > 0 ? myarr[0]['rowData']['bgColor'] : '';

    let myrowData = {};
    this.constructRowData(answers, myrowData);

    newRow['rowData'] = { ...myrowData, 'moduleId': mymid, examTitle, seTitle, 'bgColor': mybgcolor };


    let mycurrentValue = myarr?.length > 0 ? JSON.parse(JSON.stringify(myarr[0].data.currentValue)) : {};
    this.constructCurrentValue(answers, mycurrentValue);

    //construct data questions
    let myquestions = myarr?.length > 0 ? JSON.parse(JSON.stringify(myarr[0].data.questions)) :
      this.realQuestionsFromTemplate(JSON.parse(JSON.stringify(questionTemplate)).questions);
    this.constructQuestions(answers, myquestions);

    newRow['data'] = {
      'cid': mixids[0], 'id': mixids[2],
      'module': mymid, 'examTitle': examTitle, 'currentValue': mycurrentValue, 'questions': myquestions
    };
    return newRow;
  }

  updateModuleByAnswers(moduleDataArr, answers, mid) {
    const rtnArr = [];
    const tobeUpdate = [];
    for (const [key, value] of Object.entries(answers)) {
      const arr = key.split('_');
      if (arr[1] === mid) {
        const newob = { cid: arr[0], id: arr[2], module: arr[1], qid: arr[3], value: value };
        tobeUpdate.push(newob);
      }
    }

    for (const e of moduleDataArr) {
      if (e.rowData.moduleId === mid) {
        tobeUpdate.forEach(an => {
          const rowDataKey = an.qid;
          e.rowData[rowDataKey] = an.value;
          e.data.questions?.map(q => {
            if (q.id === an.qid) {
              //handle checkbox
              if (Array.isArray(an.value)) {
                q.current_value = an.value.filter(e => e !== '').join('|');
              }
              else {
                q.current_value = an.value;
              }
            }
          });
          //update e.data.currentValue for future collect answers
          if (Array.isArray(an.value)) {
            e.data.currentValue[an.qid] = an.value.filter(e => e !== '').join('|');
          }
          else {
            e.data.currentValue[an.qid] = an.value;
          }
        });
      }
      rtnArr.push(e);
    }
    return rtnArr;
  }

  deleteModuleById(moduleDataArr, mid) {
    const rtnArr = [];
    for (const e of moduleDataArr) {
      if (e.rowData.moduleId !== mid) {
        rtnArr.push(e);
      }
    }
    return rtnArr;
  }

  sortAPCP(moduleDataArr) {
    moduleDataArr.sort((a, b) => {
      if (a.rowData.examTitle > b.rowData.examTitle) { return 1; }
      
      if (a.rowData.examTitle === b.rowData.examTitle) {
        if(a.rowData.apcpMinScoreRequired&&b.rowData.apcpMinScoreRequired){
          return a.rowData.apcpMinScoreRequired > b.rowData.apcpMinScoreRequired ? 1 : -1;
        }
        else if(a.rowData.apcpMinScoreRequired&&!b.rowData.apcpMinScoreRequired){
          return 1;
        }
        else {return -1;}
      }

      if (a.rowData.examTitle < b.rowData.examTitle) { return -1; }
    });
    //udpate bgcolor
    this.addBgClass(moduleDataArr);

    return moduleDataArr;
  }

  checkModuleErrors(moduleErrors) {
    for (const key of Object.keys(moduleErrors)) {
      const errorarray = moduleErrors[key];
      if (errorarray.length > 0) {
        return true;
      }
    }
    return false;
  }

  findAllModulesIdMap(jsonContext) {
    let map = jsonContext.modules?.reduce(function (previousValue, currentValue) {
      const newjson = {};
      newjson[`${currentValue['id']}`] = currentValue['title'];
      return { ...previousValue, ...newjson };
    }, {});
    return map;
  }

  matchQuestionsToAnswers(rowDataArr, jsonContext) {
    //split answerData
    const answersData = JSON.parse(JSON.stringify(jsonContext)).modules?.filter(m => m.current_value && m.current_value.length > 0); //filter out currentvalues empty []
    const questionsData = JSON.parse(JSON.stringify(jsonContext)).modules[0].question_groups[0].questions;
    let newAnswerDataArr = [];

    const cid = jsonContext.id;
    const id = questionsData[0].question_group;

    for (const ad of answersData) {
      const { current_value } = ad;
      const examTitle = ad.title;
      const seTitle = this.shortName(examTitle);
      const module_id = ad.id;

      if (current_value.length === 0) { continue; }

      if (current_value.length > 0) {
        for (const [i, cv] of current_value.entries()) {
          let module = `${module_id}-${i}`;
          let currentValue = cv;
          newAnswerDataArr.push({ module, examTitle, seTitle, currentValue, cid, id });
        }
      }
    }

    for (const a of newAnswerDataArr) {
      const { module, examTitle, seTitle, currentValue } = a;
      const newa = { moduleId: module, examTitle, seTitle, ...currentValue };
      rowDataArr.push(newa);
    }

    const updateArr = newAnswerDataArr.map(m => {
      //module.currentvalue:{score, creditAwarded, schoolmajors,....}
      const questions = [];
      //find questions in questionsData by key
      for (let q of questionsData) {
        for (const key in m.currentValue) {
          q.id = key;
          if (q.api_attribute === key) {
            q.current_value = m.currentValue[key];
          }
        }
        questions.push({ ...q, id: q.api_attribute, current_value: m.currentValue[q.api_attribute] });
      }
      return { ...m, questions };
    });
    return { cid, id, modules: updateArr };
  }

  createNewPolicy(idMap, defaultQuestions) {
    const questions = [...newpolicyData.questions, ...defaultQuestions.questions];
    const { cid, id } = defaultQuestions;
    const module = 'NEW';

    //update 'exam titles' input options
    let options = [...Object.values(idMap)].sort();
    questions[0].input_options = [...options];
    return { cid, id, module, questions };
  }

  findModuleNameById(appliedIds, idMap) {
    let moduleNames = [];
    if (idMap && Object.keys(idMap).length > 0) {
      appliedIds.forEach(a => {
        Object.keys(idMap).forEach(k => {
          if (k === a) {
            moduleNames.push(idMap[k]);
          }
        });
      });
    }
    return moduleNames;
  }

  shortName(str) {
    if (str.length > 100) {
      return `${str.substring(0, 100)} ... `;
    }
    return str;
  }
}

export default new APCPUtil();